/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Existsaspect2Inputs */

const de__class_existsaspect2 = /** @type {(inputs: _Class_Existsaspect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`existiert`)
};

/**

* @param {_Class_Existsaspect2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_existsaspect2 = /** @type {((inputs?: _Class_Existsaspect2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Existsaspect2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_existsaspect2(inputs)
});
export { _class_existsaspect2 as "_class_ExistsAspect" }